import { Composer } from "vue-i18n";
import { i18n } from "@/i18n";
import IOrganization, {
	ICreateOrganizationData,
	IOrganizationDetails,
	IUpdateOrganizationData,
} from "@/interfaces/organizations/iOrganization";
import { get, post, put } from "./apiService";

const localization: Composer = i18n.global;
// trailing slash matches the Flask route and avoids a redirect
const BASE_URL = "organizations/";

export const getOrganizations = async (): Promise<IOrganization[]> => {
	const result = await get<IOrganization[]>(BASE_URL);

	if (result.status !== 200) {
		const errorMessage = localization.t("errors.cannot-connect-server", {
			status: result.status,
			statusText: result.statusText,
		});
		throw new Error(errorMessage);
	}

	if (!result.data) {
		const errorMessage = localization.t("errors.cannot-get-organizations-data");
		throw new Error(errorMessage);
	}

	return result.data;
};

export const createOrganization = async (
	data: ICreateOrganizationData
): Promise<void> => {
	await post<{ id: string }>(`${BASE_URL}new`, data);
};

export const getOrganization = async (
	id: string
): Promise<IOrganizationDetails> => {
	const result = await get<IOrganizationDetails>(`${BASE_URL}${id}`);

	if (result.status !== 200) {
		const errorMessage = localization.t("errors.cannot-connect-server", {
			status: result.status,
			statusText: result.statusText,
		});
		throw new Error(errorMessage);
	}

	if (!result.data) {
		const errorMessage = localization.t("errors.cannot-get-organizations-data");
		throw new Error(errorMessage);
	}

	return result.data;
};

export const updateOrganization = async (
	data: IUpdateOrganizationData
): Promise<void> => {
	await put<{ message: string }>(`${BASE_URL}update`, data);
};
